<template>
  <div
    :class="{'text-4xl': !small, 'text-custom-size': small}"
    class="font-serif"
  ><slot /></div>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css" scoped>
.text-custom-size {
  font-size: 25px;
  line-height: 36px;
}
</style>
